import CardStatus from '../SlotListCard/CardStatus';
import { Box, Card, Flex, Text } from '@chakra-ui/react';
import { getCapacityForLessonType, getLessonTypeForCode } from '@opanuj/shared/utils';

function SlotGridCard({
	slot,
	isSelected,
	isConflictWithSelected = false,
	selectedConflictIssue,
	onSelect,
	onOpenActions,
}: {
	slot: any;
	isSelected: boolean;
	isConflictWithSelected?: boolean;
	selectedConflictIssue?: any;
	onSelect: () => void;
	onOpenActions: () => void;
}) {
	const details = [
		`${slot?.duration ?? 0}min`,
		slot?.location,
		slot?.room ? `sala ${slot.room}` : null,
	]
		.filter(Boolean)
		.join(' • ');

	const isHidden = Boolean(slot?.hidden);
	const reservationCount = slot?.reservations?.length ?? 0;
	const lessonType = getLessonTypeForCode(slot?.code ?? '');
	const capacity = lessonType ? getCapacityForLessonType(lessonType) : undefined;
	const hasReservations = reservationCount > 0;
	const isStarted = Boolean(slot?.started);
	const isFull = hasReservations && capacity !== undefined && reservationCount >= capacity;
	const isPartiallyFilled = hasReservations && capacity !== undefined && reservationCount < capacity;
	const isBlocked = Boolean(slot?.isBlocked);
	const cardBorderColor = isSelected ? 'blue.400' : isConflictWithSelected ? 'red.300' : 'gray.200';
	const cardBackgroundImage = isHidden
		? 'repeating-linear-gradient(135deg, rgba(0,0,0,0.03), rgba(0,0,0,0.03) 8px, rgba(0,0,0,0.00) 8px, rgba(0,0,0,0.00) 16px)'
		: isStarted && hasReservations
			? 'repeating-linear-gradient(135deg, var(--chakra-colors-blue-50), var(--chakra-colors-blue-50) 8px, var(--chakra-colors-cyan-50) 8px, var(--chakra-colors-cyan-50) 16px)'
		: isPartiallyFilled
			? 'repeating-linear-gradient(135deg, rgba(103, 232, 249, 0.5), rgba(103, 232, 249, 0.5) 8px, rgba(103, 232, 249, 0.0) 8px, rgba(103, 232, 249, 0.0) 16px)'
			: undefined;
	const cardBackground = isBlocked ? 'red.50' : isHidden ? 'gray.100' : isStarted ? 'blue.50' : isFull ? 'cyan.100' : hasReservations ? 'cyan.50' : 'white';

	return (
		<Card.Root
			size="sm"
			role="group"
			cursor="pointer"
			onClick={onSelect}
			borderWidth="1px"
			borderColor={cardBorderColor}
			bg={cardBackground}
			position="relative"
			overflow="hidden"
			backgroundImage={cardBackgroundImage}
			boxShadow={isSelected ? '0 0 0 1px var(--chakra-colors-blue-400)' : 'none'}
			_hover={{ borderColor: 'blue.300' }}
		>
			<Card.Body position="relative" px={2} py={1.5} display="flex" gap={2} pr={20}>
				<Flex direction="column" minW={0} flex="1">
					<Text fontSize="sm" fontWeight="semibold" truncate>
						{slot?.code}
					</Text>
					<Text fontSize="xs" color="gray.600" truncate>
						{slot?.defaultTeacher}
					</Text>
					<Text fontSize="xs" color="gray.700" truncate>
						{details}
					</Text>
				</Flex>
				<Box position="absolute" top={1.5} right={2}>
					<CardStatus slot={slot} selectedConflictIssue={selectedConflictIssue} />
				</Box>
			</Card.Body>
		</Card.Root>
	);
}

export default SlotGridCard;
